class Main {
    /**
     * Initialize methods
     *
     * @memberof Main
     */
    init() {
        // Menu
        const menuTrigger = document.getElementById("js-MobileMenuTrigger");
        const menuEl = document.getElementById("js-MobileMenu");
        const wrapperEl = document.getElementById("js-MenuWrapper");

        // SmoothScroll
        const scrollTriggers = document.querySelectorAll(".js-ScrollTo");

        this.lazyLoad();
        this.scrollToContentListener(scrollTriggers);
        this.mobileMenu(menuTrigger, menuEl, wrapperEl);
    }

    /**
     * Listen to selected elements click
     *
     * @param {Object} triggers
     * @memberof Main
     */
    scrollToContentListener(triggers) {
        triggers.forEach(e => {
            e.addEventListener("click", () => {
                const target = document.getElementById(e.dataset.target);
                const diff = e.hasAttribute("data-diff") ? e.dataset.diff : 0;

                window.scroll({
                    behavior: "smooth",
                    left: 0,
                    top:
                        target.getBoundingClientRect().top +
                        window.scrollY -
                        diff
                });
            });
        });
    }

    /**
     * Control mobile menu behavior
     *
     * @param {Object} trigger Clickable button element
     * @param {Object} element Menu element
     * @param {Object} wrapper Menu wrapper element
     * @memberof Main
     */
    mobileMenu(trigger, element, wrapper) {
        const touchedClass = "touched";
        const openedMenuClass = "opened";

        trigger.addEventListener("click", () => {
            if (trigger.classList.contains(touchedClass)) {
                trigger.classList.remove(touchedClass);
                element.classList.remove(openedMenuClass);
                wrapper.classList.remove(openedMenuClass);
                //console.log("zamknijto");
            } else {
                trigger.classList.add(touchedClass);
                element.classList.add(openedMenuClass);
                wrapper.classList.add(openedMenuClass);
                //console.log("otworz");
            }
        });
    }

    /**
     * Lazy images loading
     *
     * @memberof Main
     */
    lazyLoad() {
        const tresh = window.innerWidth < 720 ? 800 : 100;

        //  lazyload.js source https://www.andreaverlicchi.eu/lazyload/
        (function(w, d) {
            let b = d.getElementsByTagName("body")[0];
            let s = d.createElement("script");
            let v = !("IntersectionObserver" in w) ? "8.17.0" : "10.19.0";
            s.async = false; // This includes the script as async. See the "recipes" section for more information about async loading of LazyLoad.
            s.src =
                "https://cdn.jsdelivr.net/npm/vanilla-lazyload@" +
                v +
                "/dist/lazyload.min.js";
            w.lazyLoadOptions = [
                {
                    elements_selector: ".lazy",
                    threshold: tresh
                },
                {
                    elements_selector: ".clazy",
                    threshold: 0,
                    callback_enter: el => {
                        el.classList.add("load-fx");
                    }
                }
            ];

            b.appendChild(s);
        })(window, document);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const main = new Main();
    main.init();

    if (!sessionStorage.getItem("show_logo")) {
        sessionStorage.setItem("show_logo", true);
        document.getElementById("thelogo").classList.add("init");
        setTimeout(() => {
            document.getElementById("thelogo").classList.remove("init");
        }, 1600);
    } else {
    }
});
